import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import * as clipboard from 'clipboard-polyfill/dist/clipboard-polyfill.promise';
import { guid } from '@/mixins/guid';
import { formatDate } from '@/mixins/format-date';
import RenewDomain from './renew-domain';
import EditRecord from './edit-record';

export default Vue.component('edit-domain', {
  template: require('./template.html'),
  name: 'edit-domain',
  mixins: [guid, formatDate],
  compontents: {
    RenewDomain,
    EditRecord,
  },
  computed: {
    ...mapGetters([
      'priceSource',
      'currentUser',
      'identityId',
    ]),
    isOwner() {
      return this.currentUser.owner && this._siteOwner;
    },
    statuses() {
      const canEditRecord = this.showRecords && this.currentDomain.managed && !this.added &&
      !this.currentDomain.expired && this.nameServersSet &&
      !this.noAddStatuses.includes(this.currentDomain.status);
      const canAutoRenew = this.currentDomain.purchased && this.canChangeAutoRenew &&
      !this.currentDomain.expired && this.isOwner;
      const purchasedAndExpiring = this.currentDomain.purchased && !this.currentDomain.autoRenew &&
      this.expiry.days && !this.currentDomain.expired && this.isOwner;
      const transferAvailable = !this.currentDomain.managed && !this.transferWanted &&
      !this.currentDomain.expired && this.isOwner;
      const transferingNoNameservers = !this.nameServersSet && this.currentDomain.status === 'IN_PROGRESS';
      const transferedChangedNameservers = !this.nameServersSet && this.currentDomain.status === 'ACTIVE';
      const transferringAndInstalling = this.currentDomain.managed && this.currentDomain.status === 'QUEUED';
      const transferringNameserversReady = this.isOwner && this.nameServersSet &&
      this.currentDomain.managed && this.currentDomain.status === 'IN_PROGRESS';
      const CNAMEinProgress = this.currentDomain.managed && this.currentDomain.status === 'RECORD_IN_PROGRESS';
      const recordInProgress = this.isOwner && this.currentDomain.managed &&
      (this.currentDomain.status === 'QUEUED' || this.currentDomain.status === 'RECORD_IN_PROGRESS');
      const purchasedAndInstalling = (this.currentDomain.purchased &&
        !this.currentDomain.hostedZoneId) || (this.currentDomain.purchased &&
        this.currentDomain.status !== 'ACTIVE');
      return {
        canEditRecord,
        canAutoRenew,
        purchasedAndInstalling,
        transferAvailable,
        transferedChangedNameservers,
        transferingNoNameservers,
        transferringNameserversReady,
        transferringAndInstalling,
        purchasedAndExpiring,
        CNAMEinProgress,
        recordInProgress,
      };
    },
  },
  props: [
    'modal',
    'current-site',
    'toggle-modal',
    'current-domain',
    'no-add-statuses',
  ],
  data() {
    return {
      loading: false,
      showRecords: false,
      addLoading: false,
      modalContent: 'list',
      newSubdomain: '',
      autoRenew: false,
      renewLoading: false,
      confirmDelDomain: false,
      confirmCancelDomain: false,
      delDomainError: false,
      delDomainLoading: false,
      checkPurchaseLoading: false,
      nameServersSet: true,
      nameServerError: false,
      transferWanted: false,
      canChangeAutoRenew: true,
      editRecordsEarly: false,
      copied: false,
      added: false,
      copies: {},
      expiry: {
        days: false,
        date: false,
      },
    };
  },
  watch: {
    modal(o) {
      if (o) {
        this.modalContent = 'list';
        this.added = false;
        this.transferWanted = false;
        this.newSubdomain = '';
        this.autoRenew = this.currentDomain.autoRenew;
        this.canChangeAutoRenew = true;
        this.confirmDelDomain = false;
        this.confirmCancelDomain = false;
        this.showRecords = true;
        this.editRecordsEarly = false;
        this.resetExpiry();
        this.checkNameServers();
        this.checkExpiry();
        this.checkPurchasedStatus();
        this.setNameServerCopies();
      } else {
        this.showRecords = false;
        this.copies = {};
      }
    },
    modalContent(v) {
      if (v === 'list') {
        this.newSubdomain = '';
      }
    },
  },
  methods: {
    async checkPurchasedStatus() {
      // if a user bought a new domain and tries to edit it, we need to
      // check if lambda finished installing it then we can save that status
      if (this.currentDomain.purchased && !this.currentDomain.hostedZoneId) {
        try {
          this.checkPurchaseLoading = true;
          const domain = `${this.currentDomain.name}${this.currentDomain.tld}`;
          const data = await this._SEND([{
            name: 'checkPurchasedStatus',
            payload: {
              site: this.currentSite._id,
              domain: this.currentDomain,
            },
          }]);

          const zone = data.zone;
          if (zone) {
            // if we reach here, we know lambda and cloudwatch installed the
            // domain! So we need to update the db with the updated zone
            this.showRecords = false;
            const hostedZoneId = zone.Id.split('/').pop();
            this.$store.dispatch('updateDomain', {
              currentDomain: this.currentDomain,
              updates: {
                hostedZoneId,
                records: [
                  {
                    _id: this.guid(),
                    domain: `www.${domain}`,
                    ttl: 0,
                    type: 'CNAME',
                    values: [
                      {
                        Value: domain,
                      },
                    ],
                  },
                ],
              },
            });
            this.showRecords = true;

            // save to db
            await this._SEND([{
              name: 'updateSiteAttr',
              payload: {
                siteId: this.currentSite._id,
                attr: 'domains',
                value: this.currentSite.domains,
              },
            }]);
            this.$log.debug('updateSiteAttr: domains');
          }
        } catch (e) {
          this.$log.error('error: ', e);
          await this._reportError({
            error: e,
            fn: 'checkPurchasedStatus',
          });
        } finally {
          this.checkPurchaseLoading = false;
        }
      }
    },
    async recheckPurchaseStatus() {
      await this.checkPurchasedStatus();
      this.$emit('check-domains');
    },
    emitCheckDomains() {
      this.$emit('check-domains');
    },
    setNameServerCopies() {
      _.forEach(this.currentDomain.nameServers, (ns, i) => {
        this.$set(this.copies, i, false);
      });
    },
    copyNameServer(ns, i) {
      clipboard.writeText(ns).then(() => {
        this.copies[i] = true;
        setTimeout(() => {
          this.copies[i] = false;
        }, 1500);
      });
    },
    async checkNameServers() {
      const d = this.currentDomain;
      const domain = `${d.name}${d.tld}`;
      try {
        this.loading = true;
        this.nameServerError = false;
        this.nameServersSet = true;
        const d = this.currentDomain;
        if (d.managed && !d.purchased) {
          const ns = _.clone(d.nameServers);
          await this.resolveNs(domain, ns);
        }
      } catch (e) {
        let error = e.message || e;
        this.$log.error(error);
        this.nameServersSet = false;
        if (error.match(/queryNs ENOTFOUND/gi)) {
          error = `It looks like the domain ${domain} does not exist yet. If you just acquired this domain, you may need to wait a few hours before it gets recognized by the internet.`;
        }
        this.nameServerError = error;
      } finally {
        this.loading = false;
      }
    },
    async resolveNs(domain, ns) {
      const nameServers = await this._SEND([{
        name: 'checkNameServers',
        payload: { domain },
      }]);
      if (nameServers && ns) {
        this.nameServersSet = _.isEqual(nameServers, ns.sort());
      } else {
        this.nameServersSet = false;
      }
    },
    async finishInstall() {
      if (!this.isOwner) {
        return;
      }
      this.loading = true;
      const notif = {
        id: this.guid(),
        type: 'success',
        message: 'Your new domain is now queued for install! This process may take a few hours to complete.',
        time: 5000,
      };
      try {
        // queue the domain cron job
        const currentUser = _.cloneDeep(this.currentUser);
        currentUser.websites = [];
        await this.$lightning([{
          name: 'queueDomainInstall',
          payload: {
            currentUser,
            currentSite: {
              _id: this.currentSite._id,
              alias: this.currentSite.alias,
              name: this.currentSite.name,
              cloudFront: this.currentSite.cloudFront,
            },
            domain: this.currentDomain,
            date: this.formatDate(Date.now()),
          },
        }]);
        // update domain with the queued state
        this.$store.dispatch('setGlobalValue', {
          item: this.currentDomain,
          key: 'status',
          value: 'QUEUED',
        });
        // save to db
        await this._SEND([{
          name: 'updateSiteAttr',
          payload: {
            siteId: this.currentSite._id,
            attr: 'domains',
            value: this.currentSite.domains,
          },
        }]);
        this.$log.debug('updateSiteAttr: domains');
        this.closeModal('editDomain');
      } catch (e) {
        this.$log.error(e);
        notif.type = 'error';
        notif.message = e.message || e;
        await this._reportError({
          error: e,
          fn: 'finishInstall',
        });
      } finally {
        this.loading = false;
        this.$store.dispatch('addNotification', notif);
      }
    },
    async recheckStatus() {
      this.loading = true;
      this.editType = null;
      try {
        const domainStatus = await this._SEND([{
          name: 'getDomainStatus',
          payload: {
            site: this.currentSite._id,
            domain: this.currentDomain._id,
          },
        }]);
        // if domain has been installed, we can reset state so user's can do more adding
        if (domainStatus.domain === 'ACTIVE' && domainStatus.cert === 'active') {
          // set state for domain
          this.$store.dispatch('setGlobalValue', {
            item: this.currentDomain,
            key: 'status',
            value: 'ACTIVE',
          });
          // set state for local cert data
          const cert = this.currentSite.SSL.certs[0];
          if (cert) {
            this.$store.dispatch('setGlobalValue', {
              item: cert,
              key: 'status',
              value: 'ACTIVE',
            });
          }
          // set state for local services data
          const sslRequests = this.currentUser.services.sslRequests;
          if (sslRequests && sslRequests.length > 0) {
            const activeCert = sslRequests.find(r => r.site === this.currentSite._id);
            if (activeCert && activeCert.status !== 'ACTIVE') {
              this.$store.dispatch('setGlobalValue', {
                item: activeCert,
                key: 'status',
                value: 'ACTIVE',
              });
            }
          }
          this.nameServersSet = true;
          this.$emit('check-domains');
        }
      } catch (e) {
        this.$log.error(e);
      } finally {
        this.loading = false;
      }
    },
    async cancelDomainRequest() {
      // this should only run on a managed domain but we can add the check anyways
      if (this.currentDomain.managed && this.isOwner) {
        this.loading = true;
        const notif = {
          id: this.guid(),
          type: 'success',
          message: `The request for ${this.currentDomain.name}${this.currentDomain.tld} has been successfully cancelled!`,
        };
        try {
          await this._SEND([{
            name: 'deleteDomain',
            payload: {
              site: this.currentSite._id,
              domain: this.currentDomain._id,
            },
          }]);

          // delete domain from state
          const fn = () => {
            const i = _.findIndex(this.currentSite.domains, d => d._id === this.currentDomain._id);
            if (i !== -1) {
              this.currentSite.domains.splice(i, 1);
            }
          };
          this.$store.dispatch('runStateFn', { fn });
          // save to db
          await this._SEND([{
            name: 'updateSiteAttr',
            payload: {
              siteId: this.currentSite._id,
              attr: 'domains',
              value: this.currentSite.domains,
            },
          }]);
          this.$log.debug('updateSiteAttr: domains');

          this.$emit('check-domains');
          this.closeModal('editDomain');
        } catch (e) {
          this.$log.error(e);
          notif.type = 'error';
          notif.message = e.message || e;
        } finally {
          this.loading = false;
          this.$store.dispatch('addNotification', notif);
          this._trackEvent({
            type: 'cancel_domain_request',
            meta: {
              site_name: this.currentSite.alias,
              site_type: this.currentSite.type,
              site_tier: this.currentSite.tier,
              domain_name: this.currentDomain.name,
              tld: this.currentDomain.tld,
            },
          });
        }
      }
    },
    async checkExpiry() {
      if (this.currentDomain.purchased && !this.currentDomain.autoRenew) {
        const expiry = await this._SEND([{
          name: 'checkDomainExpiry',
          payload: {
            siteId: this.currentSite._id,
            domain: this.currentDomain,
            today: new Date(),
          },
        }]);
        this.$log.debug('Checked domain expiry: ', expiry);

        this.expiry.days = expiry.days;
        this.expiry.date = expiry.date;
        this.canChangeAutoRenew = expiry.canChangeAutoRenew;
        this.$store.dispatch('updateDomain', {
          currentDomain: this.currentDomain,
          updates: {
            expired: expiry.expired,
          },
        });
      }
    },
    async deleteDomain() {
      const managed = this.currentDomain.managed;
      this.delDomainError = false;
      this.delDomainLoading = true;
      this.confirmDelDomain = false;
      try {
        if (managed) {
          await this._SEND([{
            name: 'deleteDomain',
            payload: {
              site: this.currentSite._id,
              domain: this.currentDomain._id,
              installed: true,
            },
          }]);
        }

        // remove from state
        const index = _.findIndex(this.currentSite.domains, d => d._id === this.currentDomain._id);
        this.$store.dispatch('deleteDomain', {
          site: this.currentSite,
          index,
        });

        // save to db
        await this._SEND([{
          name: 'updateSiteAttr',
          payload: {
            siteId: this.currentSite._id,
            attr: 'domains',
            value: this.currentSite.domains,
          },
        }]);
        this.$log.debug('updateSiteAttr: domains');

        this.closeModal('editDomain');

        // send off notification
        this.$store.dispatch('addNotification', {
          id: this.guid(),
          type: 'success',
          message: 'Successfully deleted domain!',
        });
      } catch (e) {
        this.delDomainError = `${e.message || e}. This has been reported.`;
        this.$log.error('error: ', e);
        await this._reportError({
          error: e,
          fn: 'deleteDomain',
        });
      } finally {
        this.delDomainLoading = false;
        this._trackEvent({
          type: 'delete_domain',
          meta: {
            site_name: this.currentSite.alias,
            site_type: this.currentSite.type,
            site_tier: this.currentSite.tier,
            domain_name: this.currentDomain.name,
            tld: this.currentDomain.tld,
          },
        });
      }
    },
    openConfirmDel() {
      if (this.isOwner) {
        this.confirmDelDomain = true;
      }
    },
    async saveAutoRenew() {
      if (this.currentDomain.autoRenew !== this.autoRenew &&
          this.canChangeAutoRenew && this.isOwner) {
        this.loading = true;
        const notif = {
          id: this.guid(),
          type: 'success',
          message: 'Successfully updated domain renewal!',
        };
        try {
          // set renew value in state first
          this.$store.dispatch('updateDomain', {
            currentDomain: this.currentDomain,
            updates: {
              autoRenew: this.autoRenew,
            },
          });
          const updateAutoRenew = await this._SEND([{
            name: 'updateAutoRenew',
            payload: {
              site: this.currentSite._id,
              domain: this.currentDomain,
              autoRenew: this.autoRenew,
            },
          }]);

          this.$log.debug('Successfully updated renew value: ', updateAutoRenew);

          // save to db
          await this._SEND([{
            name: 'updateSiteAttr',
            payload: {
              siteId: this.currentSite._id,
              attr: 'domains',
              value: this.currentSite.domains,
            },
          }]);
          this.$log.debug('updateSiteAttr: domains');
        } catch (e) {
          this.$log.error('error: ', e);
          notif.type = 'error';
          notif.message = `${e.message || e}. This has been reported.`;
          await this._reportError({
            error: e,
            fn: 'saveAutoRenew',
          });
        } finally {
          this.loading = false;
          this.closeModal('editDomain');
          setTimeout(() => {
            this.$store.dispatch('addNotification', notif);
          }, 500);
        }
      }
    },
    resetExpiry() {
      this.expiry = {
        date: false,
        days: false,
      };
    },
    trimText() {
      // remove anything other than a number or letter
      this.newSubdomain = this.newSubdomain.replace(/[^a-zA-Z0-9]/g, '');
    },
    seperateCamalCase(str) {
      return str.replace(/([A-Z])/g, g => ` ${g[0].toLowerCase()}`);
    },
    formatErrors(errs) {
      return this.seperateCamalCase(errs.join(' '));
    },
    closeModal(type) {
      this.$emit('toggle-modal', type, 'child');
    },
    setAdded(v) {
      this.added = v;
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/websites/edit-site/domains/edit-domain/index.js